import { useState } from "react";
import { deleteAccount } from "../api/auth";

const DeleteAccountModal = ({ currentUser, onClose }) => {
  const [deleteError, setDeleteError] = useState("");
  const [deleting, setDeleting] = useState(false);

  /**
   * 예전엔 여기서 books 전체를 순회하며 completedBy/emotions/memos 를 지우고,
   * 다른 유저의 manualFriends/notifications 를 훑고, 고아 책까지 직접 정리했다 (80여 줄).
   * 그 과정에서 클라이언트가 남의 문서를 수정해야 했다.
   *
   * 이제 profiles 행 하나가 사라지면 on delete cascade 가 전부 정리한다.
   * auth.users 삭제는 service_role 이 필요해 Edge Function 이 대신 수행하며,
   * 그 함수는 요청자의 JWT 를 검증해 "본인만" 지운다.
   */
  const handleDeleteAccount = async () => {
    if (!currentUser || currentUser.isAnonymous) return;
    setDeleteError("");
    setDeleting(true);
    try {
      await deleteAccount();
    } catch (e) {
      setDeleteError(`탈퇴 실패: ${e.message}`);
      setDeleting(false);
    }
  };

  return (
    <div className="delete-modal-overlay" onClick={() => !deleting && onClose()}>
      <div className="delete-modal" onClick={e => e.stopPropagation()}>
        <h3>회원 탈퇴</h3>
        <p className="delete-modal-warn">탈퇴하면 모든 데이터가 삭제되며 복구할 수 없어요.</p>
        <p className="delete-modal-google">Google 계정 재인증이 필요해요.</p>
        {deleteError && <div className="delete-modal-error">{deleteError}</div>}
        <div className="delete-modal-actions">
          <button className="btn-delete-confirm" onClick={handleDeleteAccount} disabled={deleting}>
            {deleting ? "탈퇴 처리 중..." : "탈퇴하기"}
          </button>
          <button className="btn-cancel" onClick={onClose} disabled={deleting}>취소</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
